<template lang="pug">
ProtexIframe(base-url='https://are.oneprotex.com/builder/')
</template>

<script setup lang="ts">
const { translateTemplate } = useTemplateTranslator()

definePageMeta({
  layout: 'blank',
  alias: '/capbuilder/',
  disableIntegrations: ['wisepops', 'liveperson'],
})

useMetaTags({
  title: translateTemplate('A.R.E. Builder [TITLE_SUFFIX]'),
  isNoIndex: true,
})
</script>
